import ("pixi.js");
declare global {
    interface Window {
        PIXI:any;
    }
}
import * as PIXI from "pixi.js";
window.PIXI = PIXI;
require("pixi-spine");
require("pixi-particles");
import {gsap} from "gsap";
import {CustomEase} from "gsap/dist/CustomEase";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {MotionPathPlugin} from "gsap/dist/MotionPathPlugin";
import {PixiPlugin} from "gsap/dist/PixiPlugin";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";

gsap.registerPlugin(CustomEase, CustomWiggle, MotionPathPlugin, PixiPlugin);
import {FireInTheHole2} from "./game/FireInTheHole2";
import {FITH2IntroConfig} from "./game/intro/FITH2IntroConfig";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {FITH2PromoPanelConfig} from "./game/FITH2PromoPanelConfig";

declare global {
    interface Window {NolimitLauncher:NolimitLauncher;}
}
window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.settings.log = LogLevel.DEV;
NolimitLauncher.instance.launch([
    new FireInTheHole2(),
    new SlotKeypad(),
    new NolimitGameIntroPlugin(new FITH2IntroConfig()),
    new NolimitSlotAudio(),
    new NolimitPromotionPlugin(new FITH2PromoPanelConfig())
]);
